import { render, staticRenderFns } from "./option-group.vue?vue&type=template&id=6685e5de&"
import script from "./option-group.vue?vue&type=script&lang=js&"
export * from "./option-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6685e5de')) {
      api.createRecord('6685e5de', component.options)
    } else {
      api.reload('6685e5de', component.options)
    }
    module.hot.accept("./option-group.vue?vue&type=template&id=6685e5de&", function () {
      api.rerender('6685e5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/select/src/option-group.vue"
export default component.exports